import { styled } from '@mui/system';
import { Table as AntdTable } from 'antd';
const resolveBorder = (theme, borderType) => {
  if (borderType === 'body') {
    return {
      '.ant-table-tbody-virtual.ant-table-tbody.ant-table-tbody-virtual': {
        border: `1px solid ${theme.tokens.ComponentTableBorderColor}`
      }
    };
  }
  return {};
};
export const StyledVirtualTable = styled(AntdTable, {
  shouldForwardProp: prop => prop != 'highlightOnHover'
})(_ref => {
  let {
    theme,
    highlightOnHover,
    headerBackgroundColor,
    dataDensity,
    sticky,
    isScrolling,
    borderType
  } = _ref;
  return {
    ...resolveBorder(theme, borderType),
    '&.ant-table-wrapper .ant-table-selection-column': {
      paddingInlineEnd: 'unset',
      paddingInlineStart: 'unset'
    },
    '&.ant-table-wrapper .ant-table-thead >tr>td': {
      border: 0
    },
    '.ant-table': {
      '& .ant-table-row .ant-table-cell': {
        padding: dataDensity === 'large' ? `${theme.tokens.ComponentTableCellPaddingLgHorizontal} ${theme.tokens.ComponentTableCellPaddingLgVertical}` : `${theme.tokens.ComponentTableCellPaddingSmHorizontal} ${theme.tokens.ComponentTableCellPaddingSmVertical}`,
        borderTop: `1px solid ${theme.tokens.ComponentTableBorderColor}`,
        minHeight: dataDensity === 'large' ? '48px' : '40px',
        height: 'fit-content',
        lineHeight: dataDensity === 'large' ? '115%' : '130%',
        fontSize: dataDensity === 'large' ? theme.tokens.ComponentTableCellFontLg : theme.tokens.ComponentTableCellFontSm,
        borderBottom: 'none',
        '&.text-right': {
          textAlign: 'right',
          alignSelf: 'flex-end'
        }
      },
      borderRadius: theme.tokens.ComponentTableBorderRadius,
      boxSizing: 'border-box',
      color: theme.tokens.ComponentTableColor,
      fontFamily: theme.tokens.ComponentTableFontFamily,
      fontWeight: theme.tokens.ComponentTableFontWeight,
      listStyle: 'none',
      margin: '0',
      overflow: 'visible',
      padding: '0',
      position: 'relative',
      '& .ant-table-container': {
        border: borderType === 'contained' ? `1px solid ${theme.tokens.ComponentTableBorderColor}` : 'none',
        borderRadius: borderType === 'contained' ? '4px' : '0',
        overflow: 'hidden',
        '& .ant-table-content': {
          '& table': {
            // sets the bottom border of the table
            borderBottom: borderType === 'contained' ? 'none' : `1px solid ${theme.tokens.ComponentTableBorderColor}`,
            '& thead': {
              '&.ant-table-thead': {
                '& .ant-table-cell': {
                  // sets the styling of the unfixed header
                  '&:before': {
                    content: 'none'
                  },
                  padding: dataDensity === 'large' ? `${theme.tokens.ComponentTableHeaderPaddingLgHorizontal} ${theme.tokens.ComponentTableHeaderPaddingLgVertical}` : `${theme.tokens.ComponentTableHeaderPaddingSmHorizontal} ${theme.tokens.ComponentTableHeaderPaddingSmVertical}`,
                  fontFamily: theme.tokens.ComponentTableHeaderFontFamily,
                  lineHeight: theme.tokens.ComponentTableHeaderLineHeight,
                  fontWeight: theme.tokens.ComponentTableHeaderFontWeight,
                  fontSize: dataDensity === 'large' ? theme.tokens.ComponentTableHeaderFontSizeLg : theme.tokens.ComponentTableHeaderFontSizeSm,
                  minHeight: dataDensity === 'large' ? '40px' : '32px',
                  boxSizing: 'border-box',
                  borderBottom: `2px solid ${headerBackgroundColor === 'dark' ? theme.tokens.ComponentTableBorderBlackColor : theme.tokens.ComponentTableBorderColor}`,
                  borderRadius: '0'
                },
                '& .text-right': {
                  textAlign: 'right'
                }
              }
            }
          }
        }
      }
    },
    '&.ant-table-wrapper .ant-table-thead .ant-table-cell:': {
      '&:after': sticky && isScrolling ? {
        display: 'block',
        boxShadow: `inset 0 6px 4px -4px ${theme.tokens.SemColorShadowMuted}`,
        position: 'absolute',
        top: 'unset',
        right: 'unset',
        left: 0,
        bottom: 0,
        transform: 'translateY(-1px)',
        width: '100%',
        color: 'transparent',
        content: `"."`,
        marginBottom: '-10px'
      } : {
        content: 'none'
      }
    },
    // sets the styling of the fixed header
    '&.ant-table-wrapper .ant-table-thead >tr>th': {
      fontFamily: theme.tokens.ComponentTableHeaderFontFamily,
      lineHeight: theme.tokens.ComponentTableHeaderLineHeight,
      fontWeight: theme.tokens.ComponentTableHeaderFontWeight,
      padding: dataDensity === 'large' ? `${theme.tokens.ComponentTableHeaderPaddingLgHorizontal} ${theme.tokens.ComponentTableHeaderPaddingLgVertical}` : `${theme.tokens.ComponentTableHeaderPaddingSmHorizontal} ${theme.tokens.ComponentTableHeaderPaddingSmVertical}`,
      fontSize: dataDensity === 'large' ? theme.tokens.ComponentTableHeaderFontSizeLg : theme.tokens.ComponentTableHeaderFontSizeSm,
      borderBottom: 'none',
      minHeight: dataDensity === 'large' ? '40px' : '32px'
    },
    '&.ant-table-wrapper table tr td.ant-table-selection-column': {
      paddingInlineStart: 'unset',
      paddingInlineEnd: 'unset',
      paddingLeft: '16px',
      paddingRight: '16px'
    },
    // removes the bar between cells of the fixed header
    '&.ant-table-wrapper .ant-table-thead >tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])': {
      '&:before': {
        content: 'none'
      }
    },
    // sets the background for the hover background of the rows

    '&.ant-table-wrapper': {
      // This modifies the box-shadow for the horizontal scroll
      '& .ant-table-ping-right .ant-table-cell-fix-right-first': {
        ':after': {
          boxShadow: `inset -6px 0 4px -4px ${theme.tokens.SemColorShadowMuted}`
        }
      },
      '& .ant-table-ping-left .ant-table-cell-fix-left-last': {
        ':after': {
          boxShadow: `inset 6px 0 4px -4px ${theme.tokens.SemColorShadowMuted}`
        }
      },
      '& .ant-table-ping-right:not(.ant-table-has-fix-right) .ant-table-container:after': {
        boxShadow: `inset -6px 0 4px -4px ${theme.tokens.SemColorShadowMuted}`
      },
      '& .ant-table-ping-left:not(.ant-table-has-fix-left) .ant-table-container:before': {
        boxShadow: `inset 6px 0 4px -4px ${theme.tokens.SemColorShadowMuted}`
      },
      // sets styling for the pagination container
      '& .ant-table-pagination': {
        display: 'none' // turning off pagination to use custom pagination
      },
      '& .ant-table-column-title': {
        flex: 'unset'
      },
      '& .ant-table-column-sorters': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '6px',
        '& > svg': {
          position: 'relative',
          top: '2px'
        }
      },
      // this rotates the expand icon
      '& .ant-table-row-icon-expand.expanded': {
        transform: 'rotate(90deg)'
      },
      '& .ant-table-cell.ant-table-expanded-row-cell': {
        '&:hover': {
          backgroundColor: theme.tokens.SemColorSurfaceInteractiveHover
        }
      },
      // this selects for the nested table of an expanded row
      '& .ant-table.ant-table-small .ant-table-tbody .ant-table-wrapper:only-child .ant-table': {
        marginBlock: 'unset',
        marginInline: 'unset'
      }
    } // end of ant table wrapper
  };
});